import { render, staticRenderFns } from "./GeoWatcher.vue?vue&type=template&id=55fab4f4&scoped=true"
import script from "./GeoWatcher.vue?vue&type=script&lang=js"
export * from "./GeoWatcher.vue?vue&type=script&lang=js"
import style0 from "./GeoWatcher.vue?vue&type=style&index=0&id=55fab4f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55fab4f4",
  null
  
)

export default component.exports